import { throttle } from "lodash"

const TABLE_SELECTOR = '.l-page-content-editor > table, .l-page-content-editor .js-anchor-main > table'
const CONTENT_WRAPPER_SELECTOR = '.l-page-content-editor'
const BEFORE_FADE_VISIBILITY_CSS_VAR = '--table-before-opacity'
const AFTER_FADE_VISIBILITY_CSS_VAR = '--table-after-opacity'
const FADES_MARGIN_CSS_VAR = '--fades-margin'
const FADES_MARGIN = 32

const getContentWidth = (table) => {
  const contentRows = getContentRows(table)
  if(!contentRows.length) return null
  return Math.max(...[...contentRows].map(contentRow => contentRow.getBoundingClientRect().width))
}

const getContentWrapperWidth = (contentWrapper) => {
  if(!contentWrapper) return null
  return contentWrapper.getBoundingClientRect().width
}

const getContentRows = (table) => table.querySelectorAll('& > tbody > tr')

const setFadesVisibility = ({ table, isLeftVisible, isRightVisible }) => {
  table.style.setProperty(
    BEFORE_FADE_VISIBILITY_CSS_VAR, 
    isLeftVisible ? 100 : 0
  )
  table.style.setProperty(
    AFTER_FADE_VISIBILITY_CSS_VAR, 
    isRightVisible ? 100 : 0
  )
}

export const tableFade = {
  init() {
    const tables = document.querySelectorAll(TABLE_SELECTOR)
    
    tables.forEach(table => {
      const contentWrapper = table.closest(CONTENT_WRAPPER_SELECTOR)
      const scrollWrapper = table.querySelector('tbody')

      if(!contentWrapper || !scrollWrapper) {
        return
      }

      table.style.setProperty(
        FADES_MARGIN_CSS_VAR,
        FADES_MARGIN
      )

      let contentWrapperWidth
      let contentWidth

      const handleFadesVisibilityOnResize = () => {
        contentWrapperWidth = getContentWrapperWidth(contentWrapper)
        contentWidth = getContentWidth(table)

        const isFadesVisible = contentWrapperWidth < contentWidth ? 100 : 0

        setFadesVisibility({
          table,
          isLeftVisible: isFadesVisible,
          isRightVisible: isFadesVisible
        })

        if(isFadesVisible) {
          handleFadesVisibilityOnScroll(scrollWrapper)
        }
      }

      const handleFadesVisibilityOnScroll = (scrollWrapper) => {
        const scrollLeft = scrollWrapper.scrollLeft;
        const scrollWidth = scrollWrapper.scrollWidth;
        const clientWidth = scrollWrapper.clientWidth;

        const [
          isScrolledToTheLeft, isScrolledToTheRight
        ] = [scrollLeft === 0, scrollLeft >= (scrollWidth - clientWidth - FADES_MARGIN)]

        setFadesVisibility({
          table,
          isLeftVisible: !isScrolledToTheLeft,
          isRightVisible: !isScrolledToTheRight
        })
      }

      handleFadesVisibilityOnResize()

      window.addEventListener('resize', throttle(handleFadesVisibilityOnResize, 200))
      scrollWrapper.addEventListener('scroll', () => {
        handleFadesVisibilityOnScroll(scrollWrapper)
      })
    })
  }
}